import { FC, PropsWithChildren } from 'react';

export const Common: FC<PropsWithChildren> = ({ children }) => {
	return <>{children}</>;
};
